<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("OrderHistory") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="topfix">
      <div class="container lg">
        <div class="tophead">
          <div class="form-group col-xs-6 m-t-n">
            <label for="filter" class="sr-only">Filter</label>
            <input
              type="text"
              class="form-control filter"
              v-model="filter"
              placeholder="Search..."
            />
          </div>
          <div
            class="col-xs-6 active text-right"
            v-if="hideotherpair"
            v-on:click="hide()"
          >
            <p class="pointer hideotherpair">
              <i class="m-r-xs fad fa-check-square"></i>
              {{ $t("HideOtherPairs") }}
            </p>
          </div>
          <div class="col-xs-6 text-right" v-else v-on:click="hide()">
            <p class="pointer hideotherpair">
              <i class="m-r-xs fad fa-square"></i>
              {{ $t("HideOtherPairs") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg animated fadeIn" v-else>
      <div v-if="table_rows.length != 0">
        <datatable
          :columns="history_columns"
          :data="table_rows"
          :filter-by="filter"
          class=""
        >
          <template slot-scope="{ row }">
            <tr class="pointer" v-on:click="expand(row._id)">
              <td colspan="5">
                <div class="row">
                  <div class="col-xs-3 text-center">
                    <p>
                      <span v-bind:class="'label ' + row.label">{{
                        row.type
                      }}</span>
                    </p>
                  </div>
                  <div class="col-xs-9">
                    <div class="row">
                      <div class="col-xs-12">
                        <span class="font-bold c-white"
                          >{{ row.pair.split("_")[0] }}/{{
                            row.pair.split("_")[1]
                          }}</span
                        >
                        <small class="pull-right">{{ row.createdAt }}</small>
                      </div>
                      <div class="col-xs-6">
                        <span class="c-white">
                          {{ ratedigi(row.rate, row.pair) }}</span
                        >
                      </div>
                      <div class="col-xs-6 text-right c-white">
                        <span v-if="row.type == 'SELL'"
                          >{{
                            volumedigi(
                              row.original_volume - row.volume,
                              row.pair
                            )
                          }}
                        </span>
                        <span v-if="row.type == 'BUY'"
                          >{{
                            volumedigi(
                              (row.original_amount - row.amount) / row.average,
                              row.pair
                            )
                          }}
                        </span>
                        {{ row.pair.split("_")[1] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12" v-if="expanded == row._id">
                    <div class="panel panel-filled m-t-sm">
                      <div class="panel-body">
                        <div class="col-xs-12 text-center ">
                          <h5 class="c-white">
                            {{ row.status }}(<span v-if="row.type == 'SELL'">{{
                              filled(row.volume, row.original_volume)
                            }}</span>
                            <span v-if="row.type == 'BUY'">{{
                              filled(row.amount, row.original_amount)
                            }}</span
                            >)
                          </h5>
                        </div>

                        <div class="col-xs-5 text-right">
                          {{ $t("Filled") }}/{{ $t("Amount") }}
                        </div>
                        <div class="col-xs-7">
                          <span class="c-white" v-if="row.type == 'SELL'"
                            >{{
                              volumedigi(
                                row.original_volume - row.volume,
                                row.pair
                              )
                            }}/{{
                              volumedigi(row.original_volume, row.pair)
                            }}</span
                          >
                          <span class="c-white" v-if="row.type == 'BUY'"
                            >{{
                              volumedigi(
                                (row.original_amount - row.amount) /
                                  row.average,
                                row.pair
                              )
                            }}/{{
                              volumedigi(
                                row.original_amount / row.average,
                                row.pair
                              )
                            }}</span
                          >
                        </div>

                        <div class="col-xs-5  text-right">
                          {{ $t("avg") }}/{{ $t("Price") }}
                        </div>
                        <div class="col-xs-7">
                          <span class=" c-white">
                            {{ ratedigi(row.average, row.pair) }}/{{
                              ratedigi(row.rate, row.pair)
                            }}
                          </span>
                        </div>

                        <div class="col-xs-5 text-right">
                          {{ $t("Fee") }}
                        </div>
                        <div class="col-xs-7">
                          <span class="c-white" v-if="row.type == 'BUY'">
                            {{ fixed(row.fee) }} {{ row.pair.split("_")[1] }}
                          </span>
                          <span class="c-white" v-if="row.type == 'SELL'">
                            {{ fixed(row.fee) }} {{ row.pair.split("_")[0] }}
                          </span>
                        </div>

                        <div class="col-xs-5 text-right">
                          {{ $t("Total") }}
                        </div>
                        <div class="col-xs-7">
                          <span class="c-white" v-if="row.type == 'SELL'"
                            >{{
                              volumedigi(
                                (row.original_volume - row.volume) *
                                  row.average,
                                row.pair
                              )
                            }}
                          </span>
                          <span class="c-white" v-if="row.type == 'BUY'"
                            >{{
                              volumedigi(
                                row.original_amount - row.amount,
                                row.pair
                              )
                            }}
                          </span>
                          {{ row.pair.split("_")[0] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
        <div class="pager-footer">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
            class="text-center"
          ></datatable-pager>
        </div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no history.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exchange from "@/api/exchange";
import moment from "moment";
import label from "@/widgets/label";
import nativeToast from "native-toast";

export default {
  data() {
    return {
      pair: null,
      hideotherpair:
        JSON.parse(localStorage.getItem("HideOtherPairs")) || false,
      ready: false,
      filter: "",
      history_columns: [
        {
          label: "",
          field: "pair",
          sortable: false,
        },
        {
          label: "",
          field: "type",
          sortable: false,
        },
        {
          label: "",
          field: "rate",
          sortable: false,
        },
        { label: "", field: "createdAt", sortable: false },
        { label: "", field: "volume", sortable: false },
      ],
      table_rows: [],
      page: 1,
      per_page: 50,
      expanded: null,
    };
  },
  computed: mapGetters(["getPairing", "getPair"]),
  methods: {
    fixed(a) {
      return a.toFixed(8);
    },
    filled(v, o) {
      return ((o - v) / (o / 100)).toFixed(2) + "%";
    },
    expand(id) {
      if (this.expanded == id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
    },
    hide() {
      this.hideotherpair = !this.hideotherpair;
      this.getdata();
      localStorage.setItem(
        "HideOtherPairs",
        JSON.stringify(this.hideotherpair)
      );
    },
    ratedigi(a, pair) {
      if (this.getPairing[pair]) {
        if (a) {
          return a.toLocaleString(undefined, {
            minimumFractionDigits: this.getPairing[pair].rate_digi,
          });
        } else {
          return a.toFixed(this.getPairing[pair].rate_digi);
        }
      } else {
        return a.toFixed(8);
      }
    },
    volumedigi(a, pair) {
      if (this.getPairing[pair]) {
        if (a) {
          return a.toLocaleString(undefined, {
            minimumFractionDigits: this.getPairing[pair].volume_digi,
          });
        } else {
          return a.toFixed(this.getPairing[pair].volume_digi);
        }
      } else {
        return a.toFixed(8);
      }
    },
    getdata() {
      this.ready = false;
      this.table_rows = [];
      exchange
        .orderhistory()
        .then((res) => {
          this.ready = true;
          res.data.forEach((e) => {
            if (e.pair == this.pair || !this.hideotherpair) {
              e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

              var a = label.type(e.type);
              e.label = a.label;

              this.table_rows.push(e);
            }
          });
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
  },
  created() {
    this.pair = this.getPair;
    this.getdata();
  },
};
</script>

<style scoped>
.container-center {
  margin-top: 67px;
  padding: 0 0 150px 0;
}
.loader-example {
  margin-top: 200px;
}
.table {
  word-wrap: break-word;
}
.hideotherpair {
  margin-top: -10px;
}
.row {
  margin-left: -8px;
  margin-right: -8px;
}
</style>
